import { SVGProps } from 'react';

const ChartNoAxesColumnDecreasing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20V10m6 10v-4M6 20V4"
    />
  </svg>
);
export default ChartNoAxesColumnDecreasing;
